import * as actionTypes from '../actions/actionTypes';

const intiData = {
    data: {},
    statuses: {
        basicDetails: {
            status: "incomplete"
        },
        sweepInstructions: {
            status: "incomplete"
        },
        accountInterestAndlimits: {
            status: "optional"
        },
        sweepGroupsAndlimits: {
            status: "optional"
        },
        orderOfSweepExecution: {
            status: "optional"
        }
    },
    activeCustomerAccordionIndex: undefined
};

export default function sowBodyReducer(state = intiData, action) {
    switch (action.type) {
        case actionTypes.SET_CURRENT_PRODUCT_GLS_CASH_CON: {
            let newState = { ...state };
            newState.data = action.productGlsCashConData;
            return newState;
        }
        case actionTypes.SET_CURRENT_PRODUCT_GLS_CASH_CON_STATUSES: {
            let newState = { ...state };
            newState.statuses = action.statuses;
            return newState;
        }
        case actionTypes.SET_CORSS_BORDER_STATUS: {
            let newState = { ...state };
            newState.crossBorder = action.CrossBorderDtata;
            return newState;
        }
        case actionTypes.SET_SOW_NEW_SWEEP_ACTIVE_TAB_INDEX: {
            let newState = { ...state };
            newState.sweepActiveTabIndex = action.index;
            return newState;
        }
        case actionTypes.RESET_NEW_SWEEP_ACTIVE_TAB_INDEX: {
            let newState = { ...state };
            newState.sweepActiveTabIndex = 0;
            return newState;
        }
        case actionTypes.SET_SOW_BODY_CUSTOMER_ACTIVE_TAB_INDEX: {
            let newState = { ...state };
            newState.activeCustomerAccordionIndex = action.index;
            return newState;
        }
        case actionTypes.RESET_SOW_BODY_CUSTOMER_ACTIVE_TAB_INDEX: {
            let newState = { ...state };
            newState.activeCustomerAccordionIndex = undefined;
            return newState;
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/SowBody/reducers/index.js